import { Avatar, Popover } from 'antd';
import React from 'react';

function NuAvatarGroupWithOutLink({ userdetails, }) {
  return (
    <>
      <Avatar.Group
        maxCount={10}
        maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf', cursor: 'pointer',textTransform: "capitalize" }}
      >
        {userdetails &&
          userdetails.map((item,index) => {
            return (
            <Popover 
            // style={{
            //   padding: '2px 2px', // Less padding inside Popover
            //   minHeight: 'unset',  // Avoid unnecessary height
            //   lineHeight: '1.2',   // Tighter line spacing
            // }} 
            content={<>
              <div className=' w-full flex items-center gap-1 text-xs'>
              <Avatar size={24} key={index} src={item.imageUrl||item.image||'#'} style={{ backgroundColor: '#048178',fontSize:'10px',fontWeight:600  }}>
                {item?.firstName?.charAt(0)||item?.name.charAt(0)||item?.userId}
              </Avatar>
              <p>{item?.firstName||item?.name||item?.userId}</p>
              </div>
            </>}             
            placement="top"
            
            >
              <Avatar size={24} key={index} src={item.imageUrl||item.image||'#'} style={{ backgroundColor: '#048178',fontSize:'10px',fontWeight:600  }}>
                {item?.firstName?.charAt(0)||item?.name.charAt(0)||item?.userId}
                
              </Avatar>
              </Popover>
            );
          })}
      </Avatar.Group>
    </>
  );
}

export default NuAvatarGroupWithOutLink;
